import React, { useState, useEffect } from "react";
import { flushSync } from "react-dom";
import { Row, Col, Card, CardBody, Table, Button, FormGroup, Label, Input, Spinner } from 'reactstrap';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import uuid from 'react-uuid';
import "../ExternalOrganisation/ExternalOrganisation.css";
import Select, { components, ValueContainerProps } from 'react-select';
import "react-datepicker/dist/react-datepicker.css"; import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";


const UserFarm = () => {
    const [userFarmList, setUserFarmList] = useState([]);
    const [tempUserFarms, setTempUserFarms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [userSelect, setUserSelect] = useState('');
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [userFarms, setUserFarms] = useState([]);
    const [saveDisabled, setSaveDisabled] = useState(false);
    const [masterCheck, setMasterCheck] = useState(false);
    const [userListFilter, setUserListFilter] = useState({ filteredUserList: [], selectedRole: 0, isOrganisationShow: false, selectedOrganisation: 0, isCertifier : false, isAuditor: false });
    const populateItemData = async () => {
        try {
            const response = await apiGet(
                '/api/settings/getuserfarms/', {
                params: {}
            }
            );
            setUserFarmList(response.data.content);
            setUserListFilter({ ...userListFilter, filteredUserList: response.data.content.users })
            setUserFarms([]);
            setLoading(false);
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }

    useEffect(() => {
        populateItemData();
    }, []);

    const handleUserChange = async (event) => {
        setUserSelect(event);
        if (event != null) {
            const response = userChange(event.value);
            toast.promise(response, {
                loading: 'Loading...',
                success: '',
                error: 'Error while loading data',
            });
            
        }
        else {
            setUserFarms([]);
            setSaveDisabled(true);
        }
    }

    const handleRoleChange = async (event) => {
        event.preventDefault();
        const selectedRoleId = event.target.value;
        const isAuditors = userListFilter.isAuditor;
        const isCertifier = userListFilter.isCertifier;

        setUserListFilter({ ...userListFilter, selectedRole: selectedRoleId })
        const response = await apiGet(
            '/api/settings/UserFarmFilter/', {
                params: { roleId: selectedRoleId,organisationId: 0, isAuditors: isAuditors, isCertifier: isCertifier }
        }
        );
        if (response.data.status) {
            const roleName = userFarmList.roleList.filter(role => role.id == selectedRoleId)[0].name;
            let isShow = roleName.includes('Organization') ? true : false;
            setUserListFilter({ ...userListFilter, filteredUserList: response.data.content, isOrganisationShow: isShow, selectedRole: selectedRoleId, selectedOrganisation: 0 })
        }

        setUserSelect(0);
        setUserFarms([]);
        setSaveDisabled(true);
    }

    const handleOrganisationChange = async (event) => {
        event.preventDefault()

        const selectedOrganisationId = event.target.value;
        const selectedRoleId = userListFilter.selectedRole;
        const isAuditors = userListFilter.isAuditor;
        const isCertifier = userListFilter.isCertifier;

        const response = await apiGet(
            '/api/settings/UserFarmFilter/', {
                params: { roleId: selectedRoleId, organisationId: selectedOrganisationId, isAuditors: isAuditors, isCertifier: isCertifier }
        }
        );
        if (response.data.status) {
            setUserListFilter({ ...userListFilter, filteredUserList: response.data.content, selectedOrganisation: selectedOrganisationId })
        }

        setUserSelect(0);
        setUserFarms([]);
        setSaveDisabled(true);
    }

    const userChange = async (userId) => {
        const response = await apiGet(
            '/api/settings/UserChange/', {
                params: { Id: userId }
        }
        );
        if (response.data.status) {
            setUserFarms(response.data.content);
            setTempUserFarms(response.data.content);
            setSaveDisabled(false);
        }
    }

    const onItemCheck = async (e, item1, type) => {

        let tempList = userFarms;
        if (type == 'farmAccess') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.farmAccess = e.target.checked;
                }
                return userFarm;
            });
        }
        else if (type == 'isFarmAdminAccess') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.isFarmAdminAccess = e.target.checked;
                }
                return userFarm;
            });
        }
        else if (type == 'isAddArchiveItem') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.isAddArchiveItem = e.target.checked;
                }
                return userFarm;
            });
        }
        else if (type == 'isAddEditItem') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.isAddEditItem = e.target.checked;
                }
                return userFarm;
            });
        }
        else if (type == 'saveRightsForNonItemFieldsAndTables') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.saveRightsForNonItemFieldsAndTables = e.target.checked;
                }
                return userFarm;
            });
        }
        else if (type == 'isCreateNewAction') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.isCreateNewAction = e.target.checked;
                }
                return userFarm;
            });
        }
        else if (type == 'isSubmitEvidenceCloseAction') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.isSubmitEvidenceCloseAction = e.target.checked;
                }
                return userFarm;
            });
        }
        else if (type == 'isAddDeleteDocument') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.isAddDeleteDocument = e.target.checked;
                }
                return userFarm;
            });
        }
        
        flushSync(() => {
            setUserFarms(prevUserFarms => {
                const newUserFarms = [...prevUserFarms];
                return newUserFarms;
            });
        });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSaveDisabled(true);
        let form = {
            UserId: userSelect.value,
            Farms: [],
            ChangedUserId: userId
        }
        for (var i = 0; i < tempUserFarms.length; i++) {
            var obj = {};
            obj.FarmId = tempUserFarms[i].farmId;
            var userFarm = userFarms.filter(x => x.farmId == tempUserFarms[i].farmId)[0];
            obj.FarmAccess = userFarm == undefined ? tempUserFarms[i].farmAccess : userFarm.farmAccess;
            obj.IsFarmAdminAccess = userFarm == undefined ? tempUserFarms[i].isFarmAdminAccess : userFarm.isFarmAdminAccess;
            obj.IsAddArchiveItem = userFarm == undefined ? tempUserFarms[i].isAddArchiveItem : userFarm.isAddArchiveItem;
            obj.IsAddEditItem = userFarm == undefined ? tempUserFarms[i].isAddEditItem : userFarm.isAddEditItem;
            obj.IsCreateNewAction = userFarm == undefined ? tempUserFarms[i].isCreateNewAction : userFarm.isCreateNewAction;
            obj.IsSubmitEvidenceCloseAction = userFarm == undefined ? tempUserFarms[i].isSubmitEvidenceCloseAction : userFarm.isSubmitEvidenceCloseAction;
            obj.IsAddDeleteDocument = userFarm == undefined ? tempUserFarms[i].isAddDeleteDocument : userFarm.isAddDeleteDocument;
            obj.SaveRightsForNonItemFieldsAndTables = userFarm == undefined ? tempUserFarms[i].saveRightsForNonItemFieldsAndTables : userFarm.saveRightsForNonItemFieldsAndTables;
            form.Farms.push(obj);
        }
        const response = await apiPost(
            '/api/settings/SaveUserFarms/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                toast.success("User Farm Associations Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setSaveDisabled(false);
                const response1 = userChange(userSelect.value);
                toast.promise(response1, {
                    loading: 'Loading...',
                    success: '',
                    error: 'Error while loading data',
                });
                setName('');
            }
        }
    }

    const onMasterCheck = async(e) => {
        let tempList = userFarms;
        tempList.map((item) => (item.farmAccess = e.target.checked));
        flushSync(() => {
            setMasterCheck(e.target.checked);
            setUserFarms(prevUserFarms => {
                const newUserFarms = [...prevUserFarms];
                return newUserFarms;
            });
        });
    }

    const onAddonCheck = async (e) => {
        e.preventDefault()

        const selectedOrganisationId = userListFilter.selectedOrganisation;
        const selectedRoleId = userListFilter.selectedRole;
        let isAuditors = userListFilter.isAuditor;
        let isCertifier = userListFilter.isCertifier;

        if (e.target.id == "certifiersCheck") {
            isCertifier = e.target.checked;
        }
        else if (e.target.id == "auditorsCheck") {
            isAuditors = e.target.checked;
        }
        const response = await apiGet(
            '/api/settings/UserFarmFilter/', {
                params: { roleId: selectedRoleId, organisationId: selectedOrganisationId, isAuditors: isAuditors, isCertifier: isCertifier }
        }
        );
        if (response.data.status) {
            setUserListFilter({ ...userListFilter, filteredUserList: response.data.content, isCertifier: isCertifier, isAuditor: isAuditors })
        }

        setUserSelect(0);
        setUserFarms([]);
        setSaveDisabled(true);
    }
    const [name, setName] = useState('');
    const handleChangeName = async (event) => {
        setName(event.target.value);
        var list = [];
        list = tempUserFarms;
        //list = tempUserFarms.filter(x => (x.farmUniqueIdentifier.toLowerCase().includes(event.target.value.toLowerCase()) || x.farmname.toLowerCase().includes(event.target.value.toLowerCase())));
        list = tempUserFarms.filter(x => (x.farmUniqueIdentifier != null ? x.farmUniqueIdentifier.toLowerCase().includes(event.target.value.toLowerCase()) : 0) || (x.farmname != null ? x.farmname.toLowerCase().includes(event.target.value.toLowerCase()) : 0));
        setUserFarms(list);
    }

    const style = {
        table: {
            width: '100%',
            display: 'table',
            borderSpacing: 0,
            borderCollapse: 'separate',
        },
        th: {
            top: 0,
            left: 0,
            zIndex: 2,
            position: 'sticky',
            backgroundColor: '#fff',
        },
    };

    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Card className="my-4">
                <h2 className="card-header card-header-dark d-flex justify-content-between align-items-center card-header">
                    User Farm Association
                </h2>
                <CardBody>
                    <Row xs="4">
                        
                        <Col className="d-flex">
                            <FormGroup>
                                <Label className="label" for="role">Role</Label>
                                {userFarmList.roleList == undefined && <p><em>Loading...</em></p>}
                                {userFarmList.roleList != undefined && userFarmList.roleList != null &&
                                    <Input type="select" value={userListFilter.selectedRole} onChange={handleRoleChange} name="role" id="role">
                                        {userFarmList.roleList.map(role =>
                                            <option key={uuid()} value={role.id}>{role.name}</option>
                                        )}
                                    </Input>
                                }
                            </FormGroup>
                        </Col>
                        {userListFilter.isOrganisationShow &&
                            <Col className="d-flex">
                                <FormGroup>
                                    <Label className="label" for="organisationSelect">Organisation</Label>
                                    {userFarmList.externalOrganisations == undefined && <p><em>Loading...</em></p>}
                                    {userFarmList.externalOrganisations != undefined && userFarmList.externalOrganisations != null &&
                                        <Input type="select" value={userListFilter.selectedOrganisation} onChange={handleOrganisationChange} name="organisationSelect" id="organisationSelect">
                                            {userFarmList.externalOrganisations.map(organisation =>
                                                <option key={uuid()} value={organisation.id}>{organisation.name}</option>
                                            )}
                                        </Input>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        <Col className="d-flex">
                            <FormGroup>
                                <Label className="label" for="userSelect">Role Add-Ons</Label> <br/>
                                <Input type="checkbox" checked={userListFilter.isCertifier} id="certifiersCheck" onChange={(e) => onAddonCheck(e)} /> Certifiers
                                <Input className="userfarm-role-addon" type="checkbox" checked={userListFilter.isAuditor} id="auditorsCheck" onChange={(e) => onAddonCheck(e)} /> Auditors
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex" sm="6">
                            <FormGroup>
                                <Label className="label" for="userSelect">User</Label>
                                {userListFilter.filteredUserList == undefined && <p><em>Loading...</em></p>}
                                {userListFilter.filteredUserList != undefined && userListFilter.filteredUserList != null &&
                                    <Select style={{ zIndex:"9999" }}
                                        id="userSelect" width="max-content"
                                        name="userSelect"
                                        closeMenuOnSelect={true}
                                        className="dropdown"
                                        placeholder="Select User"
                                        value={userSelect}
                                        options={userListFilter.filteredUserList}
                                        onChange={handleUserChange}
                                        isClearable hideSelectedOptions={false}
                                    />
                                }
                            </FormGroup>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col sm="1">
                            <Input type="checkbox" checked={masterCheck} id="masterCheck" onChange={(e) => onMasterCheck(e)} disabled={saveDisabled} />&nbsp;&nbsp;&nbsp;&nbsp;Select All
                        </Col>
                        <Col sm="2">
                            <FormGroup>
                                <Input className="validate" type="text" value={name} onChange={handleChangeName} name="Name" id="Name" placeholder="Search farm..." />
                            </FormGroup>
                        </Col>
                        <Col sm="9">
                            {userFarms.length > 0 && 
                                <>
                                {saveDisabled ?
                                    <>
                                        <Button onClick={handleSubmit} style={{ float: "right" ,marginRight:"2vw"}} id="btnSave" className="btn btn-save" color="success" disabled size="sm">
                                            <Row>
                                                <Col sm="6">
                                                    <span>
                                                        {' '}Saving
                                                    </span>
                                                </Col>
                                                <Col sm="6">
                                                    <Spinner size="sm">
                                                        Saving...
                                                    </Spinner>
                                                </Col>
                                            </Row></Button>{' '}
                                    </>
                                    :
                                    <>
                                        <Button style={{ float: "right", marginRight: "2vw" }} onClick={handleSubmit} id="btnSave" className="btn btn-save" color="success" size="sm">
                                            Save
                                        </Button>{' '}
                                    </>
                                }
                                </>    
                            }
                            

                            {/*<Button disabled={saveDisabled} id="btnSave"  onClick={handleSubmit} className="btn btn-save">Save</Button>*/}
                        </Col>
                    </Row>
                    
                    <Row className ="userFarm-tabledetails">
                        <Col>
                            <Table striped bordered hover style={style.table}>
                                <thead style={style.th}>
                                    <tr>
                                        <th style={{ width: "5%", borderWidth: "1px 1px" }} rowSpan="2">Farm Access</th>
                                        <th style={{ width: "15%", borderWidth: "1px 1px" }} rowSpan="2">Unique Identifier</th>
                                        <th style={{ width: "32%", borderWidth: "1px 1px" }} rowSpan="2">Farm Name</th>
                                        <th style={{ width: "15%", borderWidth: "1px 1px" }} rowSpan="2">Access Expiry</th>
                                        <th style={{ width: "8%", borderWidth: "1px 1px", textAlign: "center" }} colSpan="1">Admin</th>
                                        <th style={{ width: "8%", borderWidth: "1px 1px", textAlign: "center" }} colSpan="3">Maps & Pages</th>
                                        <th style={{ width: "8%", borderWidth: "1px 1px", textAlign: "center" }} colSpan="2">Actions</th>
                                        <th style={{ width: "8%", borderWidth: "1px 1px", textAlign: "center" }}>Documents</th>
                                    </tr>
                                    <tr>
                                        <th style={{ width: "8%", borderWidth: "1px 1px" }}>Farm Admin Access</th>
                                        <th style={{ width: "8%", borderWidth:"1px 1px" }}>Add / Archive Item</th>
                                        <th style={{ width: "8%", borderWidth:"1px 1px" }}>Add / Edit Record</th>
                                        <th style={{ width: "8%", borderWidth:"1px 1px" }}>SAVE rights for non-item fields and tables</th>
                                        <th style={{ width: "8%", borderWidth:"1px 1px" }}>Create New</th>
                                        <th style={{ width: "8%", borderWidth:"1px 1px" }}>Submit Evidence and Close</th>
                                        <th style={{ width: "8%", borderWidth: "1px 1px" }}>Add / Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userFarms == undefined &&
                                        <tr><td colSpan="3" style={{ textAlign: "center" }}>Loading...</td></tr>
                                    }
                                    {userFarms != undefined && userFarms != null && userFarms.map(item => (
                                        <tr key={item.farmId} >
                                            <td><Input type="checkbox" checked={item.farmAccess} key={item.farmId} id={"chk_" + item.farmId} onChange={(e) => {  onItemCheck(e, item, 'farmAccess') }} /></td>
                                            <td>{item.farmUniqueIdentifier}</td>
                                            <td>{item.farmname}</td>
                                            <td>
                                                {item.accessExpiryText}
                                            </td>
                                            <td><Input type="checkbox" disabled={!item.farmAccess} checked={item.isFarmAdminAccess} key={item.farmId} id={"chkIsFarmAdminAccess_" + item.farmId} onChange={(e) => onItemCheck(e, item, 'isFarmAdminAccess')} /></td>
                                            <td><Input type="checkbox" disabled={!item.farmAccess} checked={item.isAddArchiveItem} key={item.farmId} id={"chkIsAddArchiveItem_" + item.farmId} onChange={(e) => onItemCheck(e, item, 'isAddArchiveItem')} /></td>
                                            <td><Input type="checkbox" disabled={!item.farmAccess} checked={item.isAddEditItem} key={item.farmId} id={"chkIsAddEditItem_" + item.farmId} onChange={(e) => onItemCheck(e, item,'isAddEditItem')} /></td>
                                            <td><Input type="checkbox" disabled={!item.farmAccess} checked={item.saveRightsForNonItemFieldsAndTables} key={item.farmId} id={"chkSaveRightsForNonItemFieldsAndTables_" + item.farmId} onChange={(e) => onItemCheck(e, item,'saveRightsForNonItemFieldsAndTables')} /></td>
                                            <td><Input type="checkbox" disabled={!item.farmAccess} checked={item.isCreateNewAction} key={item.farmId} id={"chkIsCreateNewAction_" + item.farmId} onChange={(e) => onItemCheck(e, item,'isCreateNewAction')} /></td>
                                            <td><Input type="checkbox" disabled={!item.farmAccess} checked={item.isSubmitEvidenceCloseAction} key={item.farmId} id={"chkIsSubmitEvidenceCloseAction_" + item.farmId} onChange={(e) => onItemCheck(e, item,'isSubmitEvidenceCloseAction')} /></td>
                                            <td><Input type="checkbox" disabled={!item.farmAccess} checked={item.isAddDeleteDocument} key={item.farmId} id={"chkIsAddDeleteDocument_" + item.farmId} onChange={(e) => onItemCheck(e, item,'isAddDeleteDocument')} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
}

export default UserFarm;
